// extracted by mini-css-extract-plugin
export default {"menuHeaderContainer":"menuItem_menuHeaderContainer__CSKqO","menuItemContainer":"menuItem_menuItemContainer__Wtqwn","menuSelected":"menuItem_menuSelected__42gCi"};